<template>
    <v-row class="container-steps">
        <v-col cols="3" align="left">
            <v-btn :disabled="step === 1" color="accent" text small @click="$emit('back')" class="normal-btn">
                {{ $t('common.back') }}
            </v-btn>
        </v-col>
        <v-col cols="6" align="center">
            <v-rating
                :value="step"
                x-small readonly
                full-icon="mdi-circle"
                empty-icon="mdi-circle-outline"
                color="secondary"
            />
        </v-col>
        <v-col cols="3" align="right">
            <v-btn v-if="canSkip" color="accent" text small @click="$emit('skip')" class="text-lowercase">
                {{ $t('common.skip') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "StepDots",
    props: {
        step: {
            type: [String, Number],
            default: 0,
        },
        canSkip: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>

.container-steps {
    position: sticky;
    top: 48px;
    margin-bottom: 48px;
    z-index: 1;
    background-color: #ffffff;
}

</style>